import type { IconTileProps } from "../types/layout.js";

const tones = {
  primary: "bg-primary/8 text-primary",
  success: "bg-success text-success-foreground",
  muted: "bg-muted/50 text-muted-foreground",
  warning: "bg-warning text-warning-foreground",
  info: "bg-info text-info-foreground",
};
export function IconTile({ children, tone = "primary" }: IconTileProps) {
  return (
    <span aria-hidden="true" className={`grid size-10 shrink-0 place-items-center rounded-xl ${tones[tone]}`}>
      {children}
    </span>
  );
}
